import { Rxios } from "@sh/fetch";
import {
  defaultRequestParamsPlugin,
  handleResponseErrorCode,
  pickResponseDataPlugin,
  consolePlugin
} from "@sh/fetch/lib/plugins";
import { axiosIntercept } from "@sh/sentry";
import { IS_PRO } from "@fresh/env";

const request = new Rxios({
  baseURL: IS_PRO ? "https://api1.34580.com" : "https://apitest.34580.com:8043",
  needCity: true
});
request
  .addPlugin(consolePlugin)
  .addPlugin(defaultRequestParamsPlugin)
  .addPlugin(function() {
    axiosIntercept(this.httpClient);
  })
  .addPlugin(handleResponseErrorCode)
  .addPlugin(pickResponseDataPlugin)
  .install();
export default request;
